<template>
    <div :class="is_mobile_app ? '': 'wrapper'">
         <section class="row back_white_contact mb-3 mx-xl-3 mx-lg-3 mx-md-1 mx-sm-1 mx-xs-1">
        <div class="col-12 d-flex justify-content-center">
                <h3 class="static_title">{{$t("PLANS_PRICING")}}</h3>

        </div>
        <div class="col-12 d-flex justify-content-center align-items-center flex-wrap">

            <p class="mr-3">{{$t("CHECK_PRICING")}}</p>
            <!--b-dropdown id="dropdown-1" 
            placeholder="Select Country" 
            class="plan_drop_btn m-md-2 mt-sm-3 mt-xs-3 " @change="checkfn">

                <b-dropdown-item v-model="status" value=0>Qatar</b-dropdown-item>
                
                <b-dropdown-divider></b-dropdown-divider>
                
                <b-dropdown-item v-model="status"  value=1>Bahrain</b-dropdown-item>
                
                <b-dropdown-divider></b-dropdown-divider>
                
                <b-dropdown-item v-model="status"  value=2>UAE</b-dropdown-item>
    
                
            </b-dropdown-->
            <b-form-select :options="options" v-model="status" class="col-3">

            </b-form-select>

        </div>
<!--Card 1-->
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 mt-5">
            
          <div class="d-block shadow_box">
              <div class="card_title">
                  <h3 class="text-capitalize">{{$t("STANDARD")}}</h3>
                  <p v-if="status == 0">
                      10% + 1.5 QAR /{{$t("PAID_TICKET")}}
                  </p>
                  <p v-if="status == 1">
                    10% + 0.150 BHD /{{$t("PAID_TICKET")}}
                  </p>
                  <p v-if="status == 2">
                    10% + 1.5 AED /{{$t("PAID_TICKET")}}
                  </p>
              </div>

              <div class="d-block">
                  <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                      {{$t("UNLIMITED_HOSTING")}}
                  </p>

                   <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                      {{$t("EVENT_LIVE")}}
                  </p>

                   <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                      {{$t("SALES_WEBSITE")}}
                  </p>

                   <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                      {{$t("LIVE_SALE_REPORT")}}
                  </p>

                   <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                      {{$t("OFFINE_SELLING")}}
                  </p>

                   <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                      {{$t("EMAIL_CONFRIMATION")}}
                  </p>

                   <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                     {{$t("SMS")}}
                  </p>

                   <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                     {{$t("PHONE_EMAIL_SUPPORT")}}
                  </p>

              </div>
          </div>
            
        </div>

<!--Card 2-->

   <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 mt-5">
            
          <div class="d-block shadow_box">
              <div class="card_title">
                  <h3 class="text-capitalize">{{$t("PROFESSIONAL")}}</h3>
                  <p v-if="status == 0">
                     15% + 1.5 QAR /{{$t("PAID_TICKET")}}
                  </p>
                    <p v-if="status == 1">
                   15% + 0.150 BHD /{{$t("PAID_TICKET")}}
                  </p>
                     <p v-if="status == 2">
                   15% + 1.5 AED /{{$t("PAID_TICKET")}}
                  </p>
              </div>

              <div class="d-block">
                  <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                      {{$t("UNLIMITED_HOSTING")}}
                  </p>

                   <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                      {{$t("EVENT_LIVE")}}
                  </p>

                   <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                      {{$t("SALES_WEBSITE")}}
                  </p>

                   <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                      {{$t("LIVE_SALE_REPORT")}}
                  </p>

                   <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                      {{$t("OFFINE_SELLING")}}
                  </p>

                   <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                      {{$t("EMAIL_CONFRIMATION")}}
                  </p>

                   <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                     {{$t("SMS")}}
                  </p>

                   <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                      {{$t("TICKET_SCANNER")}}
                  </p>

                   <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                      {{$t("EVENT_HOSTING")}}
                  </p>

                   <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                     {{$t("PHONE_CHAT")}}
                  </p>

              </div>
          </div>
            
        </div>

<!--Card 3-->

   <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 mt-5">
            
          <div class="d-block shadow_box">
              <div class="card_title">
                  <h3 class="text-capitalize">{{$t("ENTERPRISE")}}</h3>
                  <button class="btn_plan" v-on:click="contact()">
                     {{$t("CONTACT_US")}}
                  </button>
              </div>

              <div class="d-block">
                  <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                      {{$t("UNLIMITED_HOSTING")}}
                  </p>

                   <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                      {{$t("EVENT_LIVE")}}
                  </p>

                   <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                      {{$t("SALES_WEBSITE")}}
                  </p>

                   <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                      {{$t("LIVE_SALE_REPORT")}}
                  </p>

                   <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                      {{$t("OFFINE_SELLING")}}
                  </p>

                   <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                      {{$t("EMAIL_CONFRIMATION")}}
                  </p>

                   <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                     {{$t("SMS")}}
                  </p>

                   <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                      {{$t("TICKET_SCANNER")}}
                  </p>

                   <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                      {{$t("EVENT_HOSTING")}}
                  </p>

                    <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                      {{$t("PLATFORM_TRANING")}}
                  </p>

                    <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                     {{$t("CUSTOM_DOMAIN")}}
                  </p>

                   <p class="d-flex justify-content-start p-2 border-bottom">
                      <img src="@/assets/img/icons/right.svg" class="correct_img pr-2">
                     {{$t("PHONE_CHAT")}}
                  </p>

              </div>
          </div>
            
        </div>


        <div class="col-12 mt-5 ">
            <p class="d-flex justify-content-xl-center justify-content-xs-start align-items-center flex-wrap">
              {{$t("FOR_MORE_DETAILS")}}: <a href="mailto:hello@wanasatime.com" style="color:#337ab7;">hello@wanasatime.com</a>  
            </p>

            <div class=" d-flex justify-content-center align-items-center mt-3">
            
             <button v-b-modal.modal-2 class="btn_pricing d-flex justify-content-center align-items-center">
                 {{$t("ANY_QUERY")}}
                 <img src="@/assets/img/icons/arrow-right.svg" class="arrow_img"/>
             
             </button>
</div>

        <b-modal 
        id="modal-2" 
            class="pricing_modal"
            hide-header
            hide-footer
            
        >
        <div class="border-bottom p-2 d-flex">
            <h3 class="mb-0">{{$t("SUBMIT_QUERIES")}}</h3>
        </div>
        <div class="m-3">
            <div class="d-flex  p-2" style="gap:15px">
                <h6 class="font-bold">{{$t("TO")}}:</h6>
                <p>hello@wanasatime.com</p>
            </div>

            <div class="d-flex  p-2" style="gap:15px">
                <h6 class="font-bold">{{$t("SUBJECT")}}:</h6>
                <p>	{{$t("QUERY_PLANS")}}</p>
            </div>


            <div class="d-flex  p-2 align-items-center justify-content-around" >
                <h6 class="font-bold">{{$t("FROM")}}:</h6>
                <input
                class="new_email"
                type="email"
                :placeholder="$t('ENTER_YOUR_EMAIL')"
                />
            </div>

             <div class="d-flex  p-2 align-items-center" style="gap:15px">
                <h6 class="font-bold">{{$t("MESSAGE")}}</h6>
                <textarea
                 class="textarea_new"
                    
                    rows="4" cols="50"
                >
                </textarea>
            </div>

            <div class="col-12 d-flex justify-content-center">
                 <button v-b-modal.modal-3 class="btn_pricing align-items-center" @click="send()">
                 {{$t("SEND")}}
             
             </button>
            </div>

            </div>

        </b-modal>

        </div>
        </section>
        </div>
</template>
<script>
export default {

    data(){
        return{
            imageRotate:false,
             status: 0,
             is_mobile_app: 0,
              options: [
          { value: '0', text: 'Qatar' },
          { value: '1', text: 'Bahrain' },
          { value: '2', text: 'UAE' }
        ]
        
        };
    },
    watch: {
    
    "$route.query": {
      handler(newVal, oldVal) {
        console.log({ newVal: { ...newVal }, oldVal: { ...oldVal } });
        const is_mobile_app = parseInt(newVal.is_mobile_app) || 0;

        this.$nextTick(() => {
          if (!!is_mobile_app) {
            this.is_mobile_app = is_mobile_app;
          }
        });
      },
      immediate: true,
    },
  },
    beforeMount(){
        this.checkfn()
    },
    methods: {
        checkfn(){
            console.log(this.status)
        },
        contact: function(){
      this.$router.push("/contact")
    },
    send(){
        alert('Thanks For Submitting Your Query')
    },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/pricing.vue